export default __webpack_public_path__ + "static/media/customers.8b7c1010.svg";